<template>
  <div
    id="menu"
    class="z2"
    :class="{ sticky: !noSticky, home: isHome, '-menu': !isHome }"
  >
    <!-- Main Top Menu -->
    <div
      v-if="showTopMenu"
      id="menu-items"
      class="z2 col-12 flex items-center justify-around sticky"
    >
      <div class="menu-wrapper" @mouseover="checkSubMenuBorder">
        <ul class="main-menu caps list-reset center mb0">
          <li class="px1 pointer">
            <router-link
              :to="{ name: 'Investigations' }"
              class="relative z1"
              :class="{
                'router-link-exact-active':
                  this.$route.meta.subMenu === 'Investigations',
                'hover-active': subMenuContent === 'Investigations',
              }"
            >
              <span class="inline-block">Investigations</span
              ><span
                class="inline-block xs-hide capitalize shrunk"
                :class="{ open: showInvestigationSubSectionText }"
                v-html="subSectionText('Investigations')"
              ></span
            ></router-link>
            <sub-menu
              :hoverItem="true"
              :class="{
                'border-bottom': subMenuBorder,
                'no-padding': subMenuPadding(),
              }"
              content="Investigations"
            ></sub-menu>
          </li>
          <li class="px1 pointer">
            <router-link
              :to="{ name: 'Exhibitions' }"
              class="relative z1"
              :class="{
                'router-link-exact-active':
                  this.$route.meta.subMenu === 'Programme',
                'hover-active': subMenuContent === 'Programme',
              }"
            >
              Programme<span
                class="xs-hide capitalize"
                v-text="subSectionText('Programme')"
              ></span
            ></router-link>
            <sub-menu
              :hoverItem="true"
              :class="{
                'border-bottom': subMenuBorder,
                'no-padding': subMenuPadding(),
              }"
              content="Programme"
            ></sub-menu>
          </li>
          <li class="px1 pointer">
            <router-link
              :to="{ name: 'About', params: { page: 'agency' } }"
              class="relative z1"
              :class="{
                'router-link-exact-active':
                  this.$route.meta.subMenu === 'About',
                'hover-active': subMenuContent === 'About',
              }"
            >
              About<span
                class="xs-hide capitalize"
                v-text="subSectionText('About')"
              ></span
            ></router-link>
            <sub-menu
              :hoverItem="true"
              :class="{
                'border-bottom': subMenuBorder,
                'no-padding': subMenuPadding(),
              }"
              content="About"
            ></sub-menu>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-if="showSingleTitle()"
      id="menu-title"
      class="z3 col-12 fixed center caps title-top"
    >
      <h1 class="max-w-lg lg:max-w-2xl xl:max-w-none overflow-hidden overflow-ellipsis whitespace-nowrap mx-auto">{{ pageTitle || "Loading ..." }}</h1>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { inViewport } from "@/utils";
import SubMenu from "@/components/SubMenu";

export default {
  name: "Menu",

  data() {
    return {
      subMenuBorder: false,
      subMenuShow: false,
      subMenuContent: false,
    };
  },

  components: {
    SubMenu,
  },

  computed: {
    ...mapState([
      "pageTitle",
      "investigationCategories",
      "showInvestigationSubSectionText",
    ]),
    isHome() {
      return this.$route.name === "Investigations";
    },
    noSticky() {
      return (
        this.$route.name === "Investigation" ||
        this.$route.name === "Exhibition"
      );
    },
    currentArea() {
      return this.investigationCategories.find((area) => {
        return area.slug === this.$route.params.areaSlug;
      });
    },
    showTopMenu() {
      // return this.$route.name === 'Investigations' ||
      //   this.$route.name === 'Exhibitions' || (this.$route.name === 'About' && this.$route.params.page === 'agency')
      return (
        this.$route.name !== "Exhibition" &&
        this.$route.name !== "Investigation" &&
        this.$route.name !== "Subdomain"
      );
    },
  },

  methods: {
    inViewport,
    showSingleTitle() {
      if (
        this.$route.name === "Investigation" ||
        this.$route.name === "Exhibition"
      ) {
        return true;
      } else {
        return false;
      }
    },
    showBorder() {
      return this.$route.meta.showMenuBorder || window.scrollY > 86;
    },
    checkSubMenuBorder() {
      this.subMenuBorder =
        this.$route.meta.showMenuBorder || window.scrollY > 86;
    },
    submenushow() {
      // this.subMenuShow = true
      // if (document.getElementById('section-submenu').getBoundingClientRect().top < 30) {
      //   this.subMenuShow = true
      // }
    },
    submenuhide() {
      // this.subMenuShow = false
      // this.subMenuContent = false
    },
    subMenuPadding() {
      let inlineSubMenuVisible = false;
      if (document.querySelector("#section-submenu")) {
        inlineSubMenuVisible = this.inViewport(
          document.querySelector("#section-submenu")
        );
      }
      return !inlineSubMenuVisible;
    },
    subSectionText(page) {
      let name = this.$route.name;
      let pageTitle = this.$route.params.page;

      if (page === "Investigations") {
        if (name === "Investigation Category") {
          return `&nbsp;→ ${this.unSlug(this.$route.params.slug)}`;
        } else if (name === "Investigation Location") {
          return `&nbsp;→ ${this.unSlug(this.$route.params.slug)}`;
        } else if (name === "Investigation Methodology") {
          return `&nbsp;→ ${this.unSlug(this.$route.params.slug)}`;
        }
      } else if (page === "Programme") {
        if (name === "Programme" && pageTitle) {
          return ` → ${pageTitle}`;
        } else if (name === "Exhibitions") {
          return ` → Exhibitions`;
        } else if (name === "Events") {
          return ` → Events`;
        } else if (name === "News") {
          return ` → News`;
        } else if (name === "Publications") {
          return ` → Publications`;
        }
      } else if (page === "About") {
        if (name === "About" && pageTitle) {
          return ` → ${pageTitle}`;
        } else if (name === "Team") {
          return ` → Team`;
        }
      }
    },
  },

  watch: {
    $route() {
      this.submenuhide();
    },
  },
};
</script>

<style lang="css" scoped>
.-menu {
  margin-top: -2.7em;
}

.title-top {
  top: 0.9em;
}
#menu {
  top: 0;
  pointer-events: none;

  &.home {
  }

  &.dark {
    color: var(--col-light);
  }
}

ul.main-menu {
  > li:hover a {
    border-bottom: 1px solid var(--red);
  }

  &:hover > li:not(:hover) a {
    border-color: transparent !important;
  }
}

#menu-items {
  pointer-events: none;

  .menu-wrapper {
    pointer-events: all;
  }
}

#menu-items,
.menu-bar {
  margin-bottom: 0.45em;
  h1 {
    padding-top: 0.85em;
  }

  ul {
    li {
      display: inline-block;

      a {
        padding-bottom: var(--link-border-padding);
      }

      a:hover,
      a.hover-active {
        border-bottom: 1px solid var(--red);
      }

      a.router-link-exact-active {
        font-style: italic;
        text-transform: none;
        border-bottom: 1px solid var(--red);
      }

      &:hover {
        .sub-menu {
          margin-top: -1px;
          display: block;
        }
      }
    }
  }

  .sub-menu {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    background: var(--col-light);
    border-top: 8px solid var(--col-light);
  }
}

#logo {
  line-height: 1;
  position: fixed;
  top: 1em;
  left: 1.4em;
  padding: 0.33em 0.9em;

  &:hover {
    padding: 0.33em 1.3em;
    color: var(--col-light);
    background: var(--red);
  }
}

.shrunk {
  display: none;

  &.open {
    display: inline-block;
  }
}
</style>
